<template>
  <DynamicScroller
    :items="items"
    :min-item-size="54"
    class="scroller px-0 mx-0"
  >
    <template #after @visible="log('after visible')">
      <v-card-title class="justify-center">
        <div v-intersect="endIntersect" />
      </v-card-title>
    </template>
    <template v-slot="{ item, index, active }">
      <DynamicScrollerItem
        :item="item"
        :active="active"
        :size-dependencies="[item.title]"
        :data-index="index"
        @visible="log('item visible')"
      >
        <v-expansion-panels flat class="mb-2">
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>
              <span class="title" v-html="item.title"></span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-divider class="mb-3"></v-divider>
              <div v-html="item.answer"></div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-btn
            right
            fixed
            style="right: -0.5em; top: -0.5em"
            @click.stop="handleBookmarkClick(item)"
            icon
            :color="
              bookmarks.includes(item.id)
                ? $store.getters.isThemeDark
                  ? `yellow`
                  : `orange darken-3`
                : $store.getters.isThemeDark
                ? `grey darken-3`
                : `grey lighten-2`
            "
            ><v-icon>mdi-bookmark</v-icon></v-btn
          >
        </v-expansion-panels>

        <!-- <v-card min-height="100" class="mb-2 mx-2">
          <v-card-title class="title" />
          <v-card-text class="body"  />
        </v-card> -->
      </DynamicScrollerItem>
    </template>
  </DynamicScroller>
</template>

<script>
import { mapGetters } from "vuex";

import bus from "@/bus";
import { axios } from "@/plugins/axios";
export default {
  props: {
    items: Array,
    canLoadMore: Boolean,
  },
  components: {},
  computed: {
    ...mapGetters({
      authUser: "auth/user",
      bookmarks: "app/learn/bookmarks",
    }),
  },
  methods: {
    handleBookmarkClick(item) {
      this.$store.dispatch("app/learn/toggleBookmark", item);
    },
    log(msg) {
      console.log(msg);
    },
    handleClick(item) {
      this.$emit("clicked", item);
    },

    endIntersect(entries, observer, isIntersecting) {
      if (isIntersecting) {
        // let moreVendors = loadMoreFromApi()
        // this.vendors = [ ...this.vendors, ...moreVendors]
        // console.log("reached-end");
        this.$emit("reachedEnd");
      }
    },
  },
};
</script>

<style scoped>
.scroller {
  height: 100%;
}

.user {
  height: 32%;
  padding: 0 12px;
  display: flex;
  align-items: center;
}
.my-list {
  height: calc(100vh - 8rem);
}
</style>
